import React from "react";
import { createRoot } from "react-dom/client";

import "bootstrap/dist/css/bootstrap.css";
import "../../common/base.scss";

import { Main } from "./main";
import { SSRDataProvider } from "../../providers/ssr-data-provider";

const container = document.querySelector("#root");
const root = createRoot(container);

root.render(
  <SSRDataProvider value={{ pathname: location.pathname }}>
    <Main />
  </SSRDataProvider>
);
